// extracted by mini-css-extract-plugin
module.exports = {"meetingLinkInfo":"MeetingLinkInfo_meetingLinkInfo__20VRm"};